import { render, staticRenderFns } from "./teaminfo.vue?vue&type=template&id=c886bcc0&scoped=true"
import script from "./teaminfo.vue?vue&type=script&lang=js"
export * from "./teaminfo.vue?vue&type=script&lang=js"
import style0 from "./teaminfo.vue?vue&type=style&index=0&id=c886bcc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c886bcc0",
  null
  
)

export default component.exports